// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_drawer-displayed_1lh3u_16xqy_149:not(#\\9 ){min-inline-size:40px}.awsui_drawer-content_1lh3u_16xqy_153:not(#\\9 ){position:fixed;z-index:830}", ""]);
// Exports
module.exports = exports;
